import { ASSIGNABLE_ROLES, roleLabel } from '../../constants/labels';
import FormSelect from '../forms/formSelect';

// Options come from the one label source (constants/labels.js): the value is
// the API role key (admin / staff / order_desk / driver / cleaner), the label
// the visible wording (Administrator, Coordinator, Dispatcher, Driver, Technician).
const options = ASSIGNABLE_ROLES.map((role) => ({ value: role, label: roleLabel(role) }));

const UserRoleSelect = ({ value, onChange, isMulti, ...rest }) => {
    return (
        <FormSelect isMulti={isMulti} {...rest}
            value={
                isMulti ? (value && value.map(val => ({ value: val, label: roleLabel(val) }))) :
                    (options.find(opt => opt.value === value) || null)
            }
            options={options}
            onChange={(option) => onChange(option && (isMulti ? option.map(opt => opt.value) : option.value))}
        />
    )
}

export default UserRoleSelect
